import * as React from "react";
var Title = function (_a) {
    var children = _a.children;
    return (React.createElement("p", { className: "title" }, children));
};
export { Title };
